"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var compat_1 = require("preact/compat");
var Overlay = function (_a) {
    var open = _a.open, closeFn = _a.closeFn;
    var modifier = open ? 'overlay--open' : '';
    return (0, preact_1.h)("div", { class: "overlay ".concat(modifier), onClick: closeFn });
};
exports.default = (0, compat_1.memo)(Overlay);
